import { Field, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import styles from './DisclaimerBanner.module.css';

type DisclaimerPropsBanner = ComponentProps & {
	fields: {
		DisclaimerBannerText: Field<string>;
	};
};

export default withDatasourceCheck()<DisclaimerPropsBanner>(DisclaimerBanner);

function DisclaimerBanner(props: DisclaimerPropsBanner): JSX.Element {
	console.log('Disclaimer Banner props', props.fields);
	return (
		<section className="padYS">
			<div className="maxWidth padX">
				<Text tag="h4" className={styles.disclaimerBannerText} field={props.fields?.DisclaimerBannerText} />
			</div>
		</section>
	);
}
